import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const createSubCategory = async (formValues) => {
  const formData = new FormData();
  formData.append("CategoryId", formValues.CategoryId);
  formData.append("SubCategoryName", formValues.SubCategoryName);
  formData.append("SubCategoryURL", formValues.SubCategoryURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  }
  const response = await axiosInstance.post("product/sub-category", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};
export const updateSubCategory = async (formValues) => {
  const formData = new FormData();
  formData.append("Id", formValues.Id);
  formData.append("CategoryId", formValues.CategoryId);
  formData.append("SubCategoryName", formValues.SubCategoryName);
  formData.append("SubCategoryURL", formValues.SubCategoryURL);
  formData.append("PageTitle", formValues.PageTitle || "");
  formData.append("MetaDescription", formValues.MetaDescription || "");
  formData.append("Published", formValues.Published.toString());
  formData.append("Featured", formValues.Featured.toString());
  formData.append("DisplayOrder", formValues.DisplayOrder.toString());
  formData.append("FullDescription", formValues.FullDescription);
  formData.append("ShortDescription", formValues.ShortDescription);

  if (formValues.ImageURLFile) {
    formData.append("ImageURLFile", formValues.ImageURLFile);
  } else {
    formData.append("ImageURLFile", null);
  }
  const response = await axiosInstance.put("product/sub-category", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
    },
  });
  return response.data;
};

export const fetchSubCategories = async () => {
  const response = await axiosInstance.get("product/sub-category", { headers });
  return response.data;
};

export const fetchSubCategoriesForReOrder = async () => {
  const response = await axiosInstance.get(
    "product/sub-category/for-re-order",
    {
      headers,
    }
  );
  return response.data;
};
export const fetchSubCategoryDropdowns = async () => {
  const response = await axiosInstance.get("product/sub-category/dropdown", {
    headers,
  });
  return response.data;
};
export const fetchSubCategoryById = async (id) => {
  const response = await axiosInstance.get(`product/sub-category/${id}`, {
    headers,
  });
  return response.data;
};

export const publishSubCategory = async (id) => {
  return await await axiosInstance.patch(`product/sub-category/${id}/publish`, {
    headers,
  });
};

export const unPublishSubCategory = async (id) => {
  return await await axiosInstance.patch(
    `product/sub-category/${id}/unpublish`,
    {
      headers,
    }
  );
};

export const markSubCategoryFeatured = async (id) => {
  return await await axiosInstance.patch(
    `product/sub-category/${id}/featured`,
    {
      headers,
    }
  );
};

export const markSubCategoryUnFeatured = async (id) => {
  return await await axiosInstance.patch(
    `product/sub-category/${id}/unfeatured`,
    {
      headers,
    }
  );
};

export const updateGalleryOrderService = async (orderData) => {
  const response = await axiosInstance.patch(
    `/product/sub-category/update-order`,
    orderData,
    {
      headers,
    }
  );
  return response.data;
};

export const deleteSubCategory = async (id) => {
  return await axiosInstance.delete(`product/sub-category/${id}`, { headers });
};
